import { makeStyles } from '@mui/styles';

const commonStatusText = {
	fontSize: '1.6rem',
	marginTop: '0.6rem'
};

export default makeStyles((theme) => ({
	gamUprConfig: {
		height: '100%',
		padding: '2rem',
		width: '110rem'
	},
	gamUprJsonInput: {
		width: '100%',
		backgroundColor: '#D7DBDD',
		marginTop: '1rem !important',
		letterSpacing: '1px'
	},
	gamUprJsonOutput: {
		backgroundColor: '#D7DBDD',
		height: '90%',
		borderRadius: '4px',
		boxShadow: ' 0 0 6px rgba(0, 0, 0, 0.4)',
		marginTop: '1rem',
		overflowY: 'scroll !important',
		maxHeight: '80vh',
		textAlign: 'left',
		padding: '2rem'
	},
	gamUprAutomationContainer: {
		width: '95%',
		margin: '4rem auto 0'
	},
	gamUprAutomationWrapper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		// padding: '3rem',
		// border: '1px solid #E4E7EC',
		// borderRadius: '20px',
		marginLeft: '1.2rem',
		// backgroundColor: '#FCFCFD',
		'&:hover': {
			borderColor: '#D0D5DD'
		}
	},
	gamUprAutomationContent: {
		display: 'flex',
		alignItems: 'center',
		gap: '2.4rem'
	},
	gamUprAutomationDot: {
		width: '2rem',
		height: '2rem',
		borderRadius: '50%',
		flexShrink: 0
	},
	gamUprAutomationDotEnabled: {
		backgroundColor: '#12B76A',
		animation: '$pulse 1.8s infinite'
	},

	gamUprAutomationDotDisabled: {
		backgroundColor: '#98A2B3',
		boxShadow: '0 0 0 1rem rgba(152, 162, 179, 0.12)'
	},

	'@keyframes pulse': {
		'0%': {
			boxShadow: '0 0 0 0 rgba(18, 183, 106, 0.4)'
		},

		'70%': {
			boxShadow: '0 0 0 1.2rem rgba(18, 183, 106, 0)'
		},

		'100%': {
			boxShadow: '0 0 0 0 rgba(18, 183, 106, 0)'
		}
	},

	gamUprAutomationHeader: {
		display: 'flex',
		alignItems: 'center',
		gap: '1rem'
	},
	gamUprAutomationTitle: {
		fontSize: '2.5rem',
		fontWeight: 700,
		lineHeight: 1.2,
		color: '#101828'
	},
	gamUprAutomationStatusEnabled: {
		...commonStatusText,
		fontWeight: 600,
		color: '#12B76A'
	},
	gamUprAutomationStatusDisabled: {
		...commonStatusText,
		fontWeight: 500,
		color: '#667085'
	},
	gamUprAutomationInfoBox: {
		marginTop: '3rem',
		padding: '2rem 3rem',
		borderRadius: '16px',
		backgroundColor: '#ECFDF3',
		border: '1px solid #ABEFC6'
	},
	gamUprAutomationInfoText: {
		fontSize: '1.7rem',
		lineHeight: 1.7,
		color: '#027A48'
	}
}));
